import React, {Component} from 'react';
import Styles from './style.css';
import {langRegister} from "../../services/langRegister";
import {cartRegister} from "../../services/cartRegister"
import {imagesRegister} from "../../services/imagesRegister"
import {quotesRegister} from "../../services/quotesRegister"
import cx from "classnames";

class ModalRenewHistory extends Component {

    constructor(props) {
        super(props);
        this.state = {
            option: null
        };
    };

    componentWillMount() {
        this.setState({
            option: this.props.option
        })
    }

    componentDidMount(){}

    _close(){
        if(this.state.option === 'autorenew'){
            this.props.setAutorenew(false);
        }else if(this.state.option === 'restart'){
            this.props.setRestart(false);
        }else{
            this.props.setAutorenew(false);
        }
    }

    _set(){
        if(this.state.option === 'autorenew'){
            this.props.setAutorenew(true);
        }else if(this.state.option === 'restart'){
            this.props.setRestart(true);
        }else{
            this.props.setAutorenew(true);
        }
    }

    _renderText(item) {
        return langRegister.get("modal-renewhistory", item);
    }

    render() {
        return (
            <div className={Styles.overlay}>
                <div className={Styles.overlayModal}>
                    <div className={Styles.overlayModalInner}>
                        <img onClick={() => this._close()}
                             className={Styles.overlayCloseButton}
                             src={require("../../assets/images/close_icon.svg")}/>
                        <div>
                            <div className={Styles.overlayModalText}>
                                <div className={Styles.overlayModalTextGreen}>{this._renderText("item_2")}</div><div>{this._renderText("item_1")}</div>
                            </div>
                        </div>
                    </div>
                    <div className={Styles.overlayModalButtons}>
                        <div className={Styles.overlayModalButtonsItem}>
                            <div onClick={() => this._close()}
                                 className={Styles.overlayModalButtonsItemButton}>
                                {this._renderText("item_4")}
                            </div>
                        </div>
                        <div className={Styles.overlayModalButtonsItem}>
                            <div onClick={() => {this._set()}} className={cx([Styles.overlayModalButtonsItemButton, Styles.buttonActive])}>
                                {this._renderText("item_3")}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ModalRenewHistory;


// WEBPACK FOOTER //
// ./src/components/modal_renewhistory/component.js